(function ($, Drupal, drupalSettings, once) {
  'use strict';

  /** CLICK ELEMENTS **/
  var $galleryFilter = $('.gallery-nav li');

  Drupal.behaviors.VideoGallery = {
    attach: function (context, settings) {
      $(once('galleryFilter', $galleryFilter)).on('click', function () {
        $('.gallery-nav li').removeClass('active');
        $(this).addClass('active');
        if ($(this).data('category') === 'All') {
          $('.component-video-gallery-video').show();
          $('.paragraph-item--video-gallery-video').css('display', 'block');
        }
        else {
          var cat = $(this).data('category');
          $('.paragraph-item--video-gallery-video').css('display', 'none');
          $('.video-gallery-video--category-' + cat).closest('.paragraph-item--video-gallery-video').css('display', 'block');
        }
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
